module.exports = __webpack_public_path__ + "img/mobile-menu.e397742d.svg";